<script>
import { toRaw } from "vue";
import Icon from "./Project/Icon.vue";
import _camelCase from "lodash/camelCase";
import { useAssets } from "@/composables/useAssets"
export default {
  props: {
    elements: {
      type: Object,
      required: true,
    },
    showModels: {
      type: Boolean,
      default: false
    },
    showProjects: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['select', 'remove'],
  components: {
    Icon
  },
  setup() {
    const { findIconByPrescriptionRows } = useAssets();
    const getIds = (array) => {
      let ids = [];
      array.forEach((el) => {
        ids.push(el.id);
      });
      return ids;
    }

    const getIcons = (tooth) => {
      return findIconByPrescriptionRows(tooth);
    }

    const modelTypes =  ['arch', 'gum', 'stump', 'custom-pin', 'gig', 'bracket', 'bar', 'base-arch'];
    const modelTypeWidths = {
        "arch": 100,
        "gum": 100,
        "stump": 50,
        "custom-pin": 40,
        "gig": 80,
        "bracket": 80,
        "bar": 80,
        "base-arch": 80
      }
      const camelCase = (str) => _camelCase(str);

    return { getIcons, getIds, toRaw, modelTypes, modelTypeWidths, camelCase };
  }
}

</script>
<template>
  <template v-if="$props.showModels">
    <template v-for="(modelType, index) in modelTypes" :key="index">
      <template v-for="(element, elementIndex) in $props.elements.models[camelCase(modelType)].elements" :key="elementIndex">
        <template v-if="! element.assets.length">
          <Icon
            class="m-1"
            label="&nbsp;"
            :data="element"
            :path="`assets/icons/model/${element.icon}.svg`"
            :path-selected="`assets/icons/model/${element.icon}-sel.svg`"
            :width="modelTypeWidths[modelType]"
            :ids="[element.slug]"
            :showRemove="true"
            @click="$emit('select', element)"
            @remove="$emit('remove', { event_type: `remove-model`, data: $event, element })"
          />
        </template>
      </template>
    </template>
  </template>
  <template v-if="$props.showProjects">
    <!-- Bridges -->
    <template v-if="$props.elements.bridges.length > 0">
      <template v-for="(bridge, index) in $props.elements.bridges" :key="index">
        <Icon :data="bridge.tooth[0]"
          :showRemove="!bridge.tooth[0].assets || bridge.tooth[0].assets.length === 0"
          :label="`D${bridge.tooth[0].zone_number}/${bridge.tooth[bridge.tooth.length - 1].zone_number}`"
          :path="`assets/icons/project/bridge/bridge.svg`"
          :path-selected="`assets/icons/project/bridge/bridge-sel.svg`" :width="180"
          :ids="getIds(toRaw(bridge.tooth))"
          :readonly="$props.readonly"
          :assets-count="bridge.tooth[0].assets?.length || 0"
          @click="$emit('select', toRaw(bridge.tooth))"
          @remove="$emit('remove', { event_type: 'remove-bridge', data: $event })" />
      </template>
    </template>

    <!-- Tooth -->
    <template v-if="$props.elements.tooth.length > 0">
      <template v-for="(teeth, index) in $props.elements.tooth" :key="index">
        <template v-for="(icon, index) in getIcons(teeth)" :key="index">
          <Icon :data="teeth" :path="`assets/icons/project/${icon}.svg`"
            :path-selected="`assets/icons/project/${icon}-sel.svg`" :width="100" :ids="getIds(toRaw([teeth]))"
            :assets-count="teeth.assets?.length || 0"
            @click="$emit('select', toRaw([teeth]))" />
        </template>
      </template>
    </template>
  </template>
</template>
